var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLoading)?_c('section',{staticClass:"loadingCustom"},[_c('div',[_c('b-spinner',{staticClass:"mr-2",attrs:{"type":"grow","variant":"dark"}}),_c('b-spinner',{staticClass:"mr-2",attrs:{"type":"grow","variant":"dark"}}),_c('b-spinner',{attrs:{"type":"grow","variant":"dark"}}),_c('h1',[_vm._v("Loading")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }